
import React from "react";
import {
    Heading,
    Table,
    TableHeader,
    TableBody,
    TableRow,
    TableHeaderItem,
    TableItem
} from "spectacle";
import TeaserItem from "../components/TeaserItem";

const chunk = (arr, n) => { if (!arr.length) return []; return [arr.slice(0, n)].concat(chunk(arr.slice(n), n)) }

const BootcampSlide = ({ title, bootcamps, slice = 3 }) =>
    <div className="bootcamp-slide">
        <Heading size={6} textColor="secondary" caps>
            {title}
        </Heading>
        <Table style={{paddingTop: '30px'}}>
            <TableHeader>
                <TableRow>
                    <TableHeaderItem></TableHeaderItem>
                    <TableHeaderItem></TableHeaderItem>
                    <TableHeaderItem></TableHeaderItem>
                </TableRow>
            </TableHeader>
            <TableBody>
                {chunk(bootcamps, 3).map(createRow)}
            </TableBody>
        </Table>
    </div>

const createRow = (items, index) =>
    <TableRow key={index} padding="30">
        {items.map(createItem)}
    </TableRow>;

const createItem = (item, index) =>
    <TableItem key={index} padding="30">
        <TeaserItem item={item} />
    </TableItem>;

export default BootcampSlide;


// WEBPACK FOOTER //
// ./src/slides/BootcampSlide.js